import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
export default CatalogObjectAdapter.extend({
  modelName: 'service-charge'
});